export class EventCenter {
    constructor({ canvasModel }) {
        // 元素高亮的事件
        this.ELEMENT_HIGHLIGHT_LISTERERS = [];
        // 元素点击
        this.ELEMENT_CLICK_LISTERERS = [];
        // 画布点击
        this.CANVAS_CLICK_LISTERERS = [];
        // 元素选中
        this.ELEMENT_SELECT_LISTERERS = [];
        // 历史记录变化
        this.COMMAND_HISTORY_CHANGE_LISTERERS = [];
        this.canvasModel = canvasModel;
    }
    trigger(event, params) {
        this[`${event}_LISTERERS`].forEach(fuc => fuc(params));
    }
    on(event, listener) {
        this[`${event}_LISTERERS`].push(listener);
    }
    off(event, listener) {
        var _a;
        const idx = (_a = this[`${event}_LISTERERS`]) === null || _a === void 0 ? void 0 : _a.findIndex(i => i === listener);
        this[`${event}_LISTERERS`].splice(idx, 1);
    }
    triggerCustomEvent(event, params) {
        if (!this[`CUSTOM_${event}_LISTERERS`]) {
            console.log(`自定义事件暂未注册: ${event}`);
        }
        else {
            this[`${event}_LISTERERS`].forEach(fuc => fuc(params));
        }
    }
    ;
    onCustomEvent(event, listener) {
        if (!this[`CUSTOM_${event}_LISTERERS`]) {
            this[`CUSTOM_${event}_LISTERERS`] = [];
        }
        this[`CUSTOM_${event}_LISTERERS`].push(listener);
    }
    ;
    offCustomEvent(event, listener) {
        var _a;
        const idx = (_a = this[`CUSTOM_${event}_LISTERERS`]) === null || _a === void 0 ? void 0 : _a.findIndex(i => i === listener);
        this[`CUSTOM_${event}_LISTERERS`].splice(idx, 1);
    }
    ;
}
//# sourceMappingURL=index.js.map